import { render, staticRenderFns } from "./countries-table.vue?vue&type=template&id=81d907bc&"
import script from "./countries-table.vue?vue&type=script&lang=ts&"
export * from "./countries-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports